/**
 * Navegação do site.
 */
export enum Links {

  Acoes_Criar = '/acoes/criar',
  Acoes_Editar = '/acoes/editar',
  Acoes_Index = '/acoes',
  Ajuda = '/ajuda',
  Atuacoes_Criar = '/atuacoes/criar',
  Atuacoes_Editar = '/atuacoes/editar',
  Atuacoes_Index = '/atuacoes',
  Auth_Google = '/auth/google',
  Auth_Login = '/login',
  Auth_Logout = '/logout',
  Auth_Obter_Token = '/login-token',
  Calendario_Criar = '/feriados/criar',
  Calendario_Editar = '/feriados/editar',
  Calendario_Index = '/feriados',
  ChangeLog = '/changelog',
  Colaborador_Criar = '/colaborador/criar',
  Colaborador_Editar = '/colaborador/editar',
  Colaborador_Index = '/colaborador',
  Comarcas_Criar = '/comarcas/criar',
  Comarcas_Editar = '/comarcas/editar',
  Comarcas_Index = '/comarcas',
  Configuracoes_Index = '/configuracoes',
  Defensor_Criar = '/defensor/criar',
  Defensor_Editar = '/defensor/editar',
  Defensor_Index = '/defensor',
  Defensor_Timeline = '/defensor/timeline',
  Defensoria_Criar = '/defensoria/criar',
  Defensoria_Editar = '/defensoria/editar',
  Defensoria_Index = '/defensoria',
  Direito_Index = '/direito',
  Diretoria_Criar = '/diretoria/criar',
  Diretoria_Editar = '/diretoria/editar',
  Diretoria_Index = '/diretoria',
  Distrito_Criar = '/distrito/criar',
  Distrito_Editar = '/distrito/editar',
  Distrito_Index = '/distrito',
  Escolha_Modulo = '/modulo',
  Estagiario_Criar = '/estagiario/criar',
  Estagiario_Editar = '/estagiario/editar',
  Estagiario_Frequencia_Painel = '/estagiario/frequencia/resumo',
  Estagiario_Index = '/estagiario',
  Estagiario_Index_Public = '/estagiario/public',
  Folha_Frequencia_Editar = '/folha-frequencia',
  Folha_Frequencia_Index = '/folhas',
  Funcao_Criar = '/funcao/criar',
  Funcao_Editar = '/funcao/editar',
  Funcao_Index = '/funcao',
  Historico_Index = '/historico',
  Home = '/home',
  Index = '/',
  Instituicoes_Criar = '/instituicoes/criar',
  Instituicoes_Editar = '/instituicoes/editar',
  Instituicoes_Index = '/instituicoes',
  Movimentacoes_Criar = '/movimentacoes/criar',
  Movimentacoes_Editar = '/movimentacoes/editar',
  Movimentacoes_Index = '/movimentacoes',
  Movimentacoes_Lista = '/movimentacoes/lista',
  Movimentacoes_Tipos_Criar = '/movimentacoes/tipos/criar',
  Movimentacoes_Tipos_Editar = '/movimentacoes/tipos/editar',
  Movimentacoes_Tipos_Index = '/movimentacoes/tipos',
  Notificacoes_index = '/notificacoes',
  Nucleo_Criar = '/nucleo/criar',
  Nucleo_Editar = '/nucleo/editar',
  Nucleo_Index = '/nucleo',
  Papeis_Criar = '/papeis/criar',
  Papeis_Editar = '/papeis/editar',
  Papeis_Index = '/papeis',
  Pessoa_Criar = '/pessoa/criar',
  Pessoa_Editar = '/pessoa/editar',
  Pessoa_Index = '/pessoa',
  Predio_Criar = '/predio/criar',
  Predio_Editar = '/predio/editar',
  Predio_Index = '/predio',
  ProcessoSeletivo_Criar = '/processo-seletivo/criar',
  ProcessoSeletivo_Editar = '/processo-seletivo/editar',
  ProcessoSeletivo_Index = '/processo-seletivo',
  ProcessoSeletivo_Analises = '/processo-seletivo/analises',
  Candidato_Inscricao = '/candidato/inscricao',
  Candidato_Inscricao_Confirmacao = '/candidato/inscricao-confirmacao',
  Candidato_Index = '/candidato/processo-seletivo',
  Candidato_Gestao_Arquivos = '/candidato/processo-seletivo/gestao-arquivos',
  ProcessoSeletivo_NaoDisponivel = '/processo-seletivo/nao-disponivel',
  Recuperar = '/recuperar',
  Regras = '/regras',
  Relatorio_Atendimentos_Solar = '/relatorios/solar/atendimentos',
  Relatorio_Defensores = '/relatorios/defensores',
  Relatorio_Estagiarios = '/relatorios/estagiarios',
  Relatorio_Ferias = '/relatorios/ferias',
  Relatorio_Lotacoes = '/relatorios/lotacoes',
  Relatorio_Lotacoes_public = '/relatorios/lotacoes/publico',
  Relatorio_Movimentacoes = '/relatorios/movimentacoes',
  Relatorio_Nucleos = '/relatorios/nucleos',
  Relatorios = '/relatorios/',
  Pontuacoes_Index = '/pontuacoes',
  Setor_Criar = '/setor/criar',
  Setor_Editar = '/setor/editar',
  Setor_Index = '/setor',
  TrocarSenha = '/trocarsenha',
  Usuario_Criar = '/usuario/criar',
  Usuario_Editar = '/usuario/editar',
  Usuario_Index = '/usuario',
  Usuario_Profile = '/usuario/perfil',
  Sessoes_Index = '/usuario/sessoes',
  Varas_Criar = '/varas/criar',
  Varas_Editar = '/varas/editar',
  Varas_Index = '/varas',
  Veirifique_Email = '/verifique-email',
  TipoGasto_Criar = '/office/tipo-gasto/criar',
  TipoGasto_Editar = '/office/tipo-gasto/editar',
  TipoGasto_Index = '/office/tipo-gasto',
  Gasto_Criar = '/office/gasto/criar',
  Gasto_Editar = '/office/gasto/editar',
  Gasto_Index = '/office/gasto',
  Versoes_index = '/versoes',
  Vinculos_Colaboradores_Index = '/vinculos_colaborador',
  Vinculos_Defensor_Index = '/vinculos_defensor',
  Vinculos_Estagio_Index = '/vinculos_estagio',
  Vinculos_Colaboradores_Criar = '/vinculos_colaborador/criar',
  Vinculos_Defensor_Criar = '/vinculos_defensor/criar',
  Vinculos_Editar = '/vinculos/editar',
  Vinculos_Estagio_Criar = '/vinculos_estagio/criar',
  Vinculos_Index = '/vinculos',
}

export default Links;
